import { EventsReducerState } from './eventsReducer.types';

export const EVENTS_REDUCER_INITIAL_STATE = Object.freeze<EventsReducerState>({
    hasReceivedEvents: {},
    hasReceivedAllEventsByAssociationId: {},
    events: {},
});
